function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.2381 4.03676C14.2381 4.33333 14.0103 4.54845 13.759 4.54845C13.5077 4.54845 13.2799 4.33333 13.2799 4.0367V1.17249C13.2799 0.875943 13.5078 0.660742 13.759 0.660742C14.0102 0.660742 14.2381 0.875943 14.2381 1.17249V4.03676Z",
  stroke: "#394167",
  strokeWidth: 0.8
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.71451 4.01184L5.71445 4.01178C5.54367 3.80052 5.24977 3.77559 5.04904 3.94962C4.8414 4.13057 4.81103 4.46045 4.98876 4.68066C4.98878 4.68069 4.98881 4.68073 4.98883 4.68076L6.76301 6.87442C6.76304 6.87445 6.76307 6.87449 6.7631 6.87452C6.86014 6.99421 6.99422 7.0521 7.12706 7.0521C7.23147 7.0521 7.3378 7.016 7.42849 6.93715L5.71451 4.01184ZM5.71451 4.01184L7.48891 6.20578C7.48898 6.20586 7.48904 6.20594 7.48911 6.20603M5.71451 4.01184L7.48911 6.20603M7.48911 6.20603C7.48912 6.20604 7.48913 6.20605 7.48914 6.20606M7.48911 6.20603L7.48914 6.20606M7.48914 6.20606C7.6667 6.42632 7.63625 6.75617 7.42861 6.93705L7.48914 6.20606Z",
  stroke: "#394167",
  strokeWidth: 0.8
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M4.06925 12.9707L4.06909 12.9717C4.02583 13.228 3.81633 13.3914 3.59898 13.3914C3.57178 13.3914 3.54421 13.389 3.51685 13.3841C3.51671 13.3841 3.51657 13.3841 3.51643 13.384L0.798497 12.8861C0.798468 12.8861 0.798438 12.8861 0.798409 12.8861C0.547502 12.84 0.357915 12.5828 0.407948 12.2906L0.408053 12.29C0.456872 12.0022 0.713597 11.8328 0.960256 11.8772C0.960377 11.8773 0.960498 11.8773 0.960619 11.8773L3.67875 12.3753C3.67876 12.3753 3.67878 12.3753 3.67879 12.3753C3.92966 12.4213 4.11929 12.6786 4.06925 12.9707Z",
  stroke: "#394167",
  strokeWidth: 0.8
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M26.5583 11.8783L26.5586 11.8782C26.8043 11.8332 27.0611 12.0017 27.1103 12.2916L27.1104 12.2922C27.1604 12.584 26.9706 12.8414 26.7202 12.8871L26.7201 12.8871L23.9998 13.3843C23.9997 13.3843 23.9996 13.3843 23.9996 13.3843C23.9726 13.3892 23.9451 13.3916 23.9176 13.3916C23.7004 13.3916 23.4907 13.2279 23.4474 12.9714L23.4474 12.9714L23.4472 12.9703C23.3972 12.6786 23.587 12.4212 23.8374 12.3755L23.8374 12.3755L26.5583 11.8783ZM23.7655 11.982C23.2874 12.0693 22.968 12.5424 23.053 13.0379L23.7655 11.982Z",
  stroke: "#394167",
  strokeWidth: 0.8
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M20.7527 6.87647L20.7525 6.87669C20.6565 6.99555 20.5227 7.05359 20.3897 7.05359C20.2854 7.05359 20.179 7.01747 20.0882 6.93852C19.8805 6.75757 19.8501 6.42735 20.0284 6.20713L20.0284 6.20711L21.803 4.01418C21.803 4.01418 21.803 4.01417 21.803 4.01417C21.9731 3.80397 22.268 3.77897 22.4676 3.9522C22.6753 4.13315 22.7056 4.46332 22.5274 4.68351L22.5273 4.68358L20.7527 6.87647Z",
  stroke: "#394167",
  strokeWidth: 0.8
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M2.63914 25.8607V22.273H24.8792V25.8607H2.63914Z",
  stroke: "#394167",
  strokeWidth: 0.8
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M6.87558 18.7048V19.1048H7.27558H10.1217H10.5217V18.7048V14.6933C10.5217 12.0945 11.7006 9.7941 13.5231 8.30493L14.5117 7.49715L13.2389 7.5964C9.67428 7.87437 6.87558 10.9584 6.87558 14.6933V18.7048ZM5.91721 14.6933C5.91721 10.1798 9.44178 6.546 13.7593 6.546C18.0769 6.546 21.6014 10.1798 21.6014 14.6933V20.1283H20.984H10.1216H5.91721V14.6933Z",
  stroke: "#394167",
  strokeWidth: 0.8
});

function SvgSosNavIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSosNavIcon);
export default __webpack_public_path__ + "static/media/SOSNavIcon.221bebdf.svg";
export { ForwardRef as ReactComponent };